//import { Env } from './env.js';
import SmoothScroll from 'smooth-scroll';
import MoveTo from 'moveto';
export class Scr {
	constructor(){
		this.EASEFUNC = { // Easeing for SmoothScroll
			easeInQuad: function (t, b, c, d) {
				t /= d;
				return c * t * t + b;
			},
			easeOutQuad: function (t, b, c, d) {
				t /= d;
				return -c * t* (t - 2) + b;
			}
		}
		this.mvt = new MoveTo({
			tolerance: 0,
			ease: 'easeInQuad',//'easeInQuad',
			duration: 800,
			callback: function(){
				//APP.autoScrollEnded();
			}
        }, this.EASEFUNC)
        
	}

	initSmoothScroll(){
		// moveTo.js
		this.triggers = document.querySelectorAll('a[href^="#"]');// this.triggers = document.querySelectorAll('.js-trigger');
		for (let i = 0; i < this.triggers.length; i++) {
			this.mvt.registerTrigger(this.triggers[i]);
		}
	}

	initSmoothScroll2(){
		// smooth-scroll.js https://github.com/cferdinandi/smooth-scroll
		// iOSのReduce motion(視差効果を減らす)設定がONの場合には動作しない
		// https://github.com/cferdinandi/smooth-scroll#reduce-motion-settings
		this.triggers = new SmoothScroll('a[href*="#"]', {
			header: 'header',
			speed: 700,
			speedAsDuration: true,
			updateURL: false //Update the URL on scroll
		});
	}

}